<ng-container *ngIf="supported && configured()">
  <div class="dictation" *transloco="let t">
    <button
      type="button"
      class="btn btn-sm btn-icon"
      [class.btn-outline-primary]="state === 'idle'"
      [class.btn-primary]="state !== 'idle'"
      [disabled]="state === 'starting' || state === 'stopping'"
      [attr.aria-pressed]="state === 'listening'"
      (click)="toggle()"
    >
      <span *ngIf="state === 'starting' || state === 'stopping'" class="spinner-border spinner-border-sm" role="status"></span>
      <i *ngIf="state === 'idle'" class="material-symbols-rounded">mic</i>
      <i *ngIf="state === 'listening'" class="material-symbols-rounded dictation__recording">stop_circle</i>
      {{ state === 'listening' ? t('dictation/stop') : state === 'starting' ? t('dictation/starting') : t('dictation/start') }}
    </button>
    <span class="dictation__live" *ngIf="state === 'listening' || state === 'stopping'" aria-live="polite">
      {{ partial || t('dictation/listening') }}
    </span>
  </div>
</ng-container>
